import { render, staticRenderFns } from "./Currencies.vue?vue&type=template&id=6c4c3134&"
import script from "./Currencies.vue?vue&type=script&lang=ts&"
export * from "./Currencies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports